import { IconSpriteBathtub, IconSpriteBed } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { PropertyModel } from 'common/data/property/model';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';

export const LeadTemplateInfoProperty: FunctionalComponent<{ property: PropertyModel }> = (props) => (
  <div className='contact-form__detail'>
    {props.property.meta.images_count !== 0 && (
      <div className='contact-form__image'>
        <ProgressiveImageComponent
          src={props.property.links.image_property}
          classname='contact-form__img'
          alt={props.property.name}
          placeholder={__('assets/common/property-placeholder-sm.svg')}
          preloader={__('assets/common/image-loader.svg')}
        />
      </div>
    )}
    <div className='contact-form__info'>
      <div className='contact-form__info-title'>
        <div className='contact-form__title'>{props.property.name}</div>
        <div className='contact-form__price'>{props.property.meta.price_text}</div>
      </div>
      <div className='contact-form__amenities'>
        {null !== props.property.bedroom_value && (
          <span className='contact-form__amenities-list'>
            {props.property.bedroom_name}
            <IconSpriteBed />
          </span>
        )}

        {null !== props.property.bathroom_value && (
          <span className='contact-form__amenities-list contact-form__amenities-list--bath'>
            {props.property.bathroom_name}
            <IconSpriteBathtub />
          </span>
        )}
      </div>
      <div className='contact-form__list'>
        <div className='contact-form__list-label'>{i18nTranslate('Agent')}:</div>
        <div className='contact-form__list-content'>{props.property.agent && `${props.property.agent.name}`}</div>
      </div>
      <div className='contact-form__list'>
        <div className='contact-form__list-label'>{i18nTranslate('Broker')}:</div>
        <div className='contact-form__list-content'>{props.property.broker && `${props.property.broker.name}`}</div>
      </div>
    </div>
  </div>
);
